var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElementUtils, CustomElement, Watch, PropertyConverters, Components } from '@pacem/pacem-core';
//namespace Pacem.Components.UI.Social {
let PacemTweetEmbedElement = class PacemTweetEmbedElement extends Components.PacemElement {
    constructor() {
        super(...arguments);
        this._scriptsLoaded = false;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'tweetid' && this._scriptsLoaded)
            this._render();
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        CustomElementUtils.importjs('https://platform.twitter.com/widgets.js').then(() => {
            this._scriptsLoaded = true;
            this._render();
        });
    }
    _render() {
        if (this.tweetid && this._scriptsLoaded) {
            twttr.ready(tw => tw.widgets.createTweet(this.tweetid, this));
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemTweetEmbedElement.prototype, "tweetid", void 0);
PacemTweetEmbedElement = __decorate([
    CustomElement({ tagName: P + '-tweetembed' })
], PacemTweetEmbedElement);
export { PacemTweetEmbedElement };
//}
